<template>
  <div class="banner_sale">
    <a
        href=""
        class="clearfix"
        @click.prevent="salesPop()"
    >
      <LOGO/>
      <span class="right dis_bn">
        <span class="dis_bn-red"><img :src="img"/></span>
        <span class="dis_bn-white"><img :src="imgWhite"/></span>
      </span>
      <span class="right ban_sale_tx">
        <span class="table100">
          <span class="table_cell">
            <span
                class="title25"
                v-html="sale.text"
            ></span>
            <span class="ban_sale_note">{{ disclaimer.sale_banner_text }}</span>
          </span>
        </span>
      </span>
      <span class="left in_bt_border ease">כן, אני רוצה</span>
    </a>
  </div>
</template>
<script>
import LOGO from "../../assets/img/carmella.svg";
import {mapActions, mapGetters, mapState} from "vuex";
import store from "../../store";

export default {
  props: ["sale"],
  store,
  data() {
    return {
      disclaimer: wpData.globalOptions,
      img: wpData.assets_url + "/layout/dis_bn.png",
      imgWhite: wpData.assets_url + "/layout/dis_bn_white.png"
    };
  },
  computed: {
    ...mapGetters({getProduct: "getProductById"}),
    saleDetails() {
      let sale_details = this.$store.state.sales.find(s => {
        if (s.code == this.sale.id) {
          return s;
        }
      });
      return sale_details;
    }
  },
  methods: {
    ...mapActions(["openPopupProduct"]),
    products() {
      return new Promise((resolve, reject) => {
        let sale_products = Object.values(this.saleDetails.products);
        this.$ajax({
          method: "POST",
          url: homeUrl + "ajax.php",
          params: {
            getProducts: "",
            ids: JSON.stringify(sale_products)
          }
        }).then(res => {
          resolve(res.data);
        });
      });
    },
    salesPop() {
      let sale_products = Object.values(this.saleDetails.products);

      this.products().then(res=>{
        console.log(res)
      })
      // if more then 1 products in sale
      if (sale_products.length > 1) {
        this.products().then(res => {
          this.$modal.show("sales-pop", {
            products: res
          });
        });
      } else { // if only 1 product in sale
        const productObj = {
          id: sale_products[0]
        };
        this.openPopupProduct([ productObj ]).then(res => {
          this.$modal.show("prod-modal");
        });
      }
    }
  },
  components: {
    LOGO
  }
}
</script>
